import { Injectable, Input } from '@angular/core';
import { SignupService } from './signup.service';
import { DataService } from '@app/core/services/data.service';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Injectable({
    providedIn: 'root'
})
export class AdditionalDetailsService {

    @Input() slideNumber: string | undefined;

    constructor(
        private signupService: SignupService,
        private dataService: DataService
    ) { }

    //schema and form are now combined...
    fetchSchema(referenceTypes: any): any {
        const yesNoPreferNotMap = this.dataService.getReferenceDataByName(referenceTypes, "cn_yesnoprefernottosay");

        return [ {
            wrappers: [ 'connectSection' ],
            props: { htmlClass: 'section' },
            fieldGroup: [
                {
                    wrappers: [ 'section' ],
                    props: { htmlClass: 'row' },
                    fieldGroup: [
                        {
                            wrappers: [ 'section' ],
                            props: { htmlClass: 'col-sm-12' },
                            fieldGroup: [
                                {
                                    key: "ethnicOrigin",
                                    type: 'select',
                                    props: {
                                        title: 'Your ethnic origin',
                                        // required: true,
                                        options: this.dataService.getReferenceDataByName(referenceTypes, "cn_ethnicorigintype")
                                    }
                                },
                                {
                                    key: "armedForces",
                                    type: "select",
                                    props: {
                                        title: "Does anybody in the household have links to the UK armed forces?",
                                        supportingText: "Excluding national service. If several household members have these links answer for regular first. If no regular answer for reserve. If no reserve answer for spouses or civil partners.",
                                        required: true,
                                        options: this.dataService.getReferenceDataByName(referenceTypes, "cn_armedforces")
                                    }
                                },
                                {
                                    expressions: {
                                        hide: (field: FormlyFieldConfig) => !(field.model.armedForces === 875970000 || field.model.armedForces === 875970001)
                                    },
                                    key: "armedForcesInjuryIllness",
                                    type: "radiobuttons",
                                    props: {
                                        required: true,
                                        title: "Was this person seriously injured or ill as a result of serving?",
                                        options: yesNoPreferNotMap,
                                        labelHtmlClass: "control-label",
                                        activeClass: "active"
                                    }
                                },
                                {
                                    expressions: {
                                        hide: (field: FormlyFieldConfig) => !(field.model.armedForces === 875970000 || field.model.armedForces === 875970001)
                                    },
                                    key: "armedForcesStillServing",
                                    type: "radiobuttons",
                                    props: {
                                        // required: true,
                                        title: "Is this person still serving?",
                                        options: this.dataService.getReferenceDataByName(referenceTypes, 'cn_arrmedforceswhendidyouleave'),
                                        labelHtmlClass: "control-label",
                                        activeClass: "active"
                                    }
                                },
                            ]
                        }
                    ]
                }
            ]
        } ]
    }
}
